module.exports = __webpack_public_path__ + "static/media/PDF_120.caaf6818.pdf";